var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.$route.name !== 'Connectwallet' && this.$route.name !== 'Shop')?_c('Topbar'):_vm._e(),_c('router-view'),(this.$route.name === 'Home')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }